import { TabStyles, TabTemplate } from "@fluentui/web-components";
import { Tab } from "./tab.js";
import { DesignSystem } from "../design-system.js";
/**
 * The Fabric Tab component
 *
 * @public
 */
export const definition = Tab.compose({
    name: `${DesignSystem.prefix}-tab`,
    template: TabTemplate,
    styles: TabStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=tab.definition.js.map